"use client"

import { RotateCw } from "lucide-react"

export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 bg-[#F2F3F5] px-4 text-center">
      <h1 className="text-[24px] leading-8 font-medium text-[#1D2129]">
        Unable to load brands
      </h1>
      <p className="text-[16px] leading-6 text-[#4E5969]">
        Please try again in a moment.
      </p>
      <button
        type="button"
        onClick={reset}
        className="inline-flex items-center gap-2 rounded-[6px] bg-[#15B25C] px-4 py-2 text-[14px] font-medium text-white hover:bg-[#0F9E4F] focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#0F9E4F]"
      >
        <RotateCw aria-hidden="true" size={16} />
        Try again
      </button>
    </div>
  )
}
